import React from "react";

import { RouteType } from "commons/types/route";

function getDefaultRoute(): RouteType {
    return {
        path: "",
        label: "",
        neededAuthorities: [],
        element: <></>,
        pathwayElements: [],
    };
}

export const RouteContext = React.createContext<RouteType>(getDefaultRoute());

export const useRouteContext = () => React.useContext(RouteContext);

type PropsType = {
    route: RouteType;
    children: any;
};

export const RouteContextProvider = (props: PropsType) => {
    return <RouteContext.Provider value={props.route}>{props.children}</RouteContext.Provider>;
};
